// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3cDDE","footer":"ModalInfo_footer__173F9"};